import { useEffect } from "react";
import Lenis from "lenis";
import { MotionConfig } from "framer-motion";
import "@/App.css";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Services } from "@/components/Services";
import { BeforeAfter } from "@/components/BeforeAfter";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <MotionConfig reducedMotion="user">
      <div className="App bg-[#FAFAFA] text-zinc-950 font-body">
        <div className="noise-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <Marquee />
          <Services />
          <BeforeAfter />
          <Testimonials />
        </main>
        <Footer />
      </div>
    </MotionConfig>
  );
}

export default App;
